import { listClusterHostGroups } from 'app/plugins/openstack/components/infrastructure/clusters/actions'
import { IClusterHostGroup } from 'app/plugins/openstack/components/infrastructure/clusters/model'
import { clusterHostGroupsSelector } from 'app/plugins/openstack/components/infrastructure/clusters/selectors'
import { UNASSIGNED_CLUSTER } from 'app/plugins/openstack/components/infrastructure/selectors'
import RadioDropdownFilter, {
  Item,
} from 'app/plugins/openstack/components/networks/dns/records/RadioDropdownFilter'
import useListAction from 'core/hooks/useListAction'
import { useCallback, useMemo } from 'react'
import { useSelector } from 'react-redux'

interface OpenstackClusterFilterDropdownProps {
  data: any[]
  setFilteredData: (hosts: any[]) => void
  refreshGraph?: boolean
}

const OpenstackClusterFilterDropdown = ({
  data,
  setFilteredData,
  refreshGraph = false,
}: OpenstackClusterFilterDropdownProps) => {
  const { loading: loadingClusters } = useListAction(listClusterHostGroups)
  const clusters = useSelector(clusterHostGroupsSelector)

  const clusterOptions = useMemo(() => {
    const unassignedOption = {
      label: `-- ${UNASSIGNED_CLUSTER} --`,
      value: UNASSIGNED_CLUSTER,
    }
    const clusterList =
      clusters?.map((cluster: IClusterHostGroup) => ({
        label: cluster?.name,
        value: cluster?.name,
      })) ?? []
    return [unassignedOption, ...clusterList]
  }, [clusters])

  // Handle Filter - Filter by Cluster
  const handleApplyFilter = useCallback(
    (selectedItems: Item[]) => {
      if (!selectedItems?.length) {
        setFilteredData([])
        return
      }

      const selectedClusters = selectedItems?.flatMap((item) => item?.value)
      setFilteredData(data?.filter((item) => selectedClusters?.includes(item?.clusterName)))

      // Send async event to update graphs when cluster filter is applied
      if (refreshGraph) {
        setTimeout(() => {
          document.dispatchEvent(new CustomEvent('refreshGraph'))
        }, 0)
      }
    },
    [data],
  )

  return (
    <RadioDropdownFilter
      width={300}
      label="Cluster"
      items={clusterOptions}
      loading={loadingClusters}
      data={data}
      handleApplyFilter={handleApplyFilter}
    />
  )
}

export default OpenstackClusterFilterDropdown
